import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Box,
  MenuItem,
  Table,
  TableBody,
  InputAdornment,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]); // Extract Base64 content
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

const AddStockReturn = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState('');
  const [branchId, setBranchId] = useState("");   
  // const [branchId, setBranchId] = useState(1); // code by nabil
  const [vendorId, setVendorId] = useState(1);
  const [branchName, setBranchName] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  });

  const [receivedDate, setReceivedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [invoiceCopy, setInvoiceCopy] = useState(null);
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({
    itemCode: "",
    quantity: "",
  });
  const [vendors, setVendors] = useState([]);
  const [branch, setBranch] = useState([]);  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [stockIssuanceId, setStockIssuanceId] = useState("");

  const [stockIssuances, setStockIssuances] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [nameOptions, setNameOptions] = useState([]);
  const [selectedName, setSelectedName] = useState("");

  const [selectedDetails, setSelectedDetails] = useState({
    quantity: 0,
    issuedToID: null,
    stockIssuanceID: null,
  });



  // Use Material-UI's useMediaQuery for responsive design
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    if (typeOptions.length > 0 && !selectedType) {
      const defaultType = typeOptions[0];
      setSelectedType(defaultType);
    }
    fetchStockIssuances();
  }, []);

  useEffect(() => {
    if (branchId) {
      fetchInventoryItems(branchId);
    }
  }, [branchId]);

  useEffect(() => {
    fetchBranch();
  }, []);

// 1. Auto-select effect — store as a string
useEffect(() => {
  if (branch.length === 1) {
    setBranchId(String(branch[0].branchId));   // was: branch[0].srBranchId
  }
}, [branch]);


  // useEffect(() => {
  //   if (branch.length > 0) {
  //     setBranchId(String(branch[0].srBranchId)); // Set default after data is loaded
  //   }
  // }, [branch]); // Runs when `branch` is updated

  useEffect(() => {
    fetchTaxRates();
  }, []);

  const fetchBranch = async () => {
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      });
      if (response.ok) {
        const responseData = await response.json();
        setBranch(responseData);
        setError("");
      } else {
        console.error("Failed to fetch branch:", response.status);
        setError("Failed to Load branch. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching branch:", error);
      setError("An error occured while loading branch.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStockIssuances = async () => {
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Inventory/StockTransaction/ListStockIssuance`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setStockIssuances(data || []);

        // Get unique types
        const types = [...new Set(data.map((item) => item.issuedToType))];
        setTypeOptions(types);
      } else {
        setError("Failed to load stock issuances.");
      }
    } catch (err) {
      console.error("Error fetching stock issuances:", err);
      setError("Error occurred while fetching stock issuances.");
    } finally {
      setIsLoading(false);
    }
  };


  const fetchInventoryItems = async (branchId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(
        `${apiUrl}/Inventory/Item/GetInventoryItems?itemId=0`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        const filteredItems = responseData.filter(
  (item) => item.branchId === parseInt(branchId, 10)
);
        setInventoryItems(filteredItems);
      } else {
        console.error("Failed to fetch inventory items:", response.status);
      }
    } catch (error) {
      console.error("Error fetching inventory items:", error);
    }
  };

  const fetchTaxRates = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Inventory/Item/GetTaxRates`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        setTaxRates(responseData.taxRates || []);
      } else {
        console.error("Failed to fetch tax rates:", response.status);
      }
    } catch (error) {
      console.error("Error fetching tax rates:", error);
    }
  };

  const handleAddItem = () => {
    if (
      newItem.itemCode &&
      newItem.quantity >= 0 &&
      newItem.unitCost >= 0 &&
      newItem.taxRate >= 0
    ) {
      setItems([...items, newItem]);
      setNewItem({ itemCode: "", quantity: "" });
    } else {
      // alert("Please fill all item fields with valid positive values.");
      setSnackbarMessage('Please fill all item fields with valid positive values.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
    }
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleReset = () => {
    // Keep branchId as is; don't reset it
    setVendorId("");
    setInvoiceNumber("");
    setInvoiceDate(() => {
      const today = new Date();
      return today.toISOString().split("T")[0];
    });
    setReceivedDate(() => {
      const today = new Date();
      return today.toISOString().split("T")[0];
    });
    setInvoiceCopy(null);
    setItems([]);
    setNewItem({ itemCode: "", quantity: "" });
    setSelectedType("");
    setSelectedName("");
    setSelectedDetails({
      quantity: 0,
      issuedToID: null,
      stockIssuanceID: null,
    });
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const isPDF = file.type === "application/pdf";
    const isImage = file.type.startsWith("image/");
    const maxPdfSize = 2 * 1024 * 1024; // 2MB in bytes
    const maxImageSize = 200 * 1024; // 200KB in bytes

    if (isPDF && file.size <= maxPdfSize) {
      setInvoiceCopy(file);
    } else if (isImage && file.size <= maxImageSize) {
      setInvoiceCopy(file);
    } else {
      // alert("Only PDF files up to 2MB or image files up to 200KB are allowed.");
      setSnackbarMessage('Only PDF files up to 2MB or image files up to 200KB are allowed.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
    }
  };


  const handleNumericInputChange = (field, value, index) => {
    const numericValue = Number(value);
    const maxQty = items[index].quantityIssued;

    if (numericValue > maxQty) return;

    const updatedItems = [...items];
    updatedItems[index][field] = numericValue;
    setItems(updatedItems);
  };

  const fetchIssuanceDetails = async (issuanceId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Inventory/StockTransaction/GetStockIssuanceDetails/${issuanceId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        const mappedItems = data.details.map((detail) => ({
          itemId: detail.itemID,
          itemCode: detail.itemCode,
          itemName: detail.itemName,
          quantityIssued: detail.quantityIssued,
          quantity: detail.quantityIssued, // default returned quantity = issued
        }));
        setItems(mappedItems);
        setInventoryItems(mappedItems); // For reference
      } else {
        console.error("Failed to fetch issuance item details");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };


  const handleSave = async () => {
    // Basic validation
    if (!selectedType || !selectedDetails.issuedToID || !invoiceDate || items.length === 0) {
      // alert("Please fill all required fields and add at least one item.");
      setSnackbarMessage('Please fill all required fields and add at least one item.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }

    // Check that at least one item has quantity > 0
    const hasValidQuantity = items.some((item) => item.quantity > 0);
    if (!hasValidQuantity) {
      // alert("At least one item must have a quantity greater than 0.");
      setSnackbarMessage('At least one item must have a quantity greater than 0.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }

    // Validate item quantities: cannot be negative or greater than issued
    const invalidItem = items.find(
      (item) => item.quantity < 0 || item.quantity > item.quantityIssued
    );
    if (invalidItem) {
      // alert("Please enter valid quantity for all items. Quantity must be 0 or less than or equal to issued quantity.");
       setSnackbarMessage('Please enter valid quantity for all items. Quantity must be 0 or less than or equal to issued quantity.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;

      // Construct payload (only include items with quantity > 0)
      const payload = {
        stockIssuanceID: selectedDetails.stockIssuanceID,
        returnedByType: selectedType,
        returnedByID: selectedDetails.issuedToID,
        returnDate: new Date(invoiceDate).toISOString(),
        items: items
          .filter((item) => item.quantity > 0)
          .map((item) => ({
            itemID: item.itemId,
            quantityReturned: parseInt(item.quantity, 10),
          })),
      };

      console.log("Sending Stock Return Payload:", payload);

      const response = await fetch(`${apiUrl}/Inventory/StockTransaction/InsertStockReturn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();
      console.log("Response from the API:", responseData);

      if (response.ok) {
        setSnackbarMessage('Stock Return Saved Successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success")

        handleReset(); // Clear the form
      } else {
        console.error("Failed to save stock return:", response.status);
        // alert("This issuance is already fully returned. No further returns are allowed.");
        setSnackbarMessage('This issuance is already fully returned. No further returns are allowed.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      }
    } catch (error) {
      console.error("Error saving stock return:", error);
      // alert("An error occurred while saving stock return.");
      setSnackbarMessage('An error occurred while saving stock return.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };



  const printReceipt = async () => {
    try {
      console.log("Starting printReceipt function");
      setIsLoading(true);

      // Gather header data
     const selectedBranch = branch.find(b => String(b.branchId) === String(branchId));
      const selectedVendor = vendors.find(v => v.vendorID === parseInt(vendorId, 10));

      const header = {
        branchName: selectedBranch?.branchName || "Branch Name",
        branchID: branchId || "Branch ID",
        issuanceCode: items.itemCode,
        issuanceDate: new Date(receivedDate).toLocaleDateString(),
        issuedToName: selectedVendor?.vendorName || "Vendor Name",
        issuedToType: "Vendor",
        issuedToID: vendorId || "Vendor ID",
        totalQuantity: items.reduce((sum, item) => sum + parseInt(item.quantity || 0, 10), 0),
        createdByName: "Current User", // Replace with actual user info if available
        createdBy: "User ID", // Replace with actual user ID if available
        createdDate: new Date().toLocaleDateString()
      };

      // Prepare item details
      const details = items.map(item => {
        const itemDetails = inventoryItems.find(i => i.itemId === item.itemCode);
        return {
          itemCode: itemDetails?.itemCode || items.itemCode,
          itemName: itemDetails?.itemName || "Item",
          quantityIssued: item.quantity
        };
      });

      // Create a hidden div to render the receipt
      console.log("Creating hidden div for rendering");
      const receiptDiv = document.createElement("div");
      receiptDiv.style.position = "absolute";
      receiptDiv.style.left = "-9999px";
      receiptDiv.style.width = "816px"; // Approx A4 width at 96dpi
      receiptDiv.innerHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Stock Inward Receipt</title>
          <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body { margin: 0; font-family: Arial, sans-serif; }
            .logo-placeholder { width: 80px; height: 80px; background: #e5e7eb; }
          </style>
        </head>
        <body class="font-sans bg-gray-100">
          <div class="max-w-3xl mx-auto bg-white p-8 my-8 rounded-lg shadow-lg">
            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
              <div class="flex items-center">
                <div class="logo-placeholder rounded-full mr-4"></div>
                <div>
                  <h1 class="text-2xl font-bold text-blue-600">${header.branchName
        }</h1>
                  <p class="text-sm text-gray-600">Stock Inward Receipt</p>
                </div>
              </div>
              <div class="text-right">
                <p>Date: ${header.issuanceDate}</p>
              </div>
            </div>
            <hr class="border-gray-300 mb-6">

            <!-- Issued To -->
            <div class="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p class="font-semibold">Issued To:</p>
                <p>${header.issuedToName} (${header.issuedToType})</p>
                <p>ID: ${header.issuedToID}</p>
              </div>
              <div>
                <p class="font-semibold">Branch:</p>
                <p>${header.branchName}</p>
                <p>Branch ID: ${header.branchID}</p>
              </div>
            </div>

            <!-- Items Table -->
            <table class="w-full border-collapse mb-6">
              <thead>
                <tr class="bg-blue-600 text-white">
                  <th class="border border-gray-300 p-3 text-left">Item Code</th>
                  <th class="border border-gray-300 p-3 text-left">Item Name</th>
                  <th class="border border-gray-300 p-3 text-right">Quantity Issued</th>
                </tr>
              </thead>
              <tbody>
                ${details
          .map(
            (item) => `
                  <tr class="hover:bg-gray-50">
                    <td class="border border-gray-300 p-3">${item.itemCode}</td>
                    <td class="border border-gray-300 p-3">${item.itemName}</td>
                    <td class="border border-gray-300 p-3 text-right">${item.quantityIssued}</td>
                  </tr>
                `
          )
          .join("")}
              </tbody>
            </table>

            <!-- Summary -->
            <div class="flex justify-end mb-6">
              <div class="text-right">
                <p class="font-semibold">Total Quantity: <span class="text-blue-600">${header.totalQuantity
        }</span></p>
              </div>
            </div>

            <!-- Created By -->
            <div class="mb-6">
              <p class="font-semibold">Created By:</p>
              <p>Created Date: ${header.createdDate}</p>
            </div>

            <!-- Footer -->
            <hr class="border-gray-300 mb-6">
            <div class="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p class="font-semibold">Authorized Signature:</p>
                <div class="h-12 border-b border-gray-300 w-48 mt-2"></div>
              </div>
              <div class="text-right">
                <p class="font-semibold">Terms:</p>
                <p class="text-sm text-gray-600">Items issued are non-returnable unless authorized.</p>
              </div>
            </div>
          </div>
        </body>
        </html>
      `;
      document.body.appendChild(receiptDiv);
      console.log("Hidden div appended to document");

      // Wait for Tailwind CSS to load and render
      console.log("Waiting for Tailwind CSS to render");
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Convert the div to canvas
      console.log("Converting div to canvas with html2canvas");
      const canvas = await html2canvas(receiptDiv, {
        scale: 2, // Higher resolution for better quality
        useCORS: true,
        logging: false,
      });

      // Remove the temporary div
      console.log("Removing temporary div");
      document.body.removeChild(receiptDiv);

      // Create PDF
      console.log("Creating PDF with jsPDF");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      // Generate blob and open in new tab
      console.log("Generating PDF blob and opening in new tab");
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const pdfWindow = window.open(pdfUrl, "_blank");

      // Trigger print dialog after PDF loads
      if (pdfWindow) {
        console.log("PDF window opened, setting onload print");
        pdfWindow.onload = () => {
          pdfWindow.print();
        };
      } else {
        console.warn(
          "Failed to open PDF window, possibly blocked by popup blocker"
        );
        setSnackbarMessage("Please allow popups to view the PDF receipt");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error in printReceipt:", error);
      setSnackbarMessage("Failed to generate PDF receipt");
      setSnackbarOpen(true);
    } finally {
      console.log("printReceipt completed, setting isLoading to false");
      setIsLoading(false);
    }
  };


  return (
    <div className="container ">
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          backgroundColor: "#0B1F40",
          color: "#fff",
          padding: "12px 20px",

          fontWeight: "bold",

          mb: 1, // margin bottom
        }}
      >
        Stock Return Form
      </Typography>
      <Paper elevation={3} style={{ padding: 16, marginTop: 0 }}>

        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",
            margin: "20px auto",
            padding: "32px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Responsive Grid Layout */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "24px",
            }}
          >
            {/* Branch Name */}

            {/* previous code */}
            {/* <div>
              <Typography variant="subtitle1" gutterBottom>
                Branch Name <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                select
                fullWidth
                variant="outlined"
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
                sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
              >
                <MenuItem value="" disabled>
                  --Select Branch--
                </MenuItem>
                {branch.map((branches) => (
                  <MenuItem key={branches.srBranchId} value={branches.srBranchId}>
                    {branches.branchName}
                  </MenuItem>
                ))}
              </TextField>
            </div> */}

            {/* latest code by nabil*/}
            {/* Branch Name */}

            {/* Branch Name */}
            <div>
              <Typography variant="subtitle1" gutterBottom>
                Branch Name <span style={{ color: "red" }}>*</span>
              </Typography>
     
<TextField
  select
  fullWidth
  variant="outlined"
  disabled={branch.length <= 1}
  value={branchId}
  onChange={(e) => {
    setBranchId(e.target.value);
    fetchInventoryItems(e.target.value);
  }}
  sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
>
  <MenuItem value="" disabled>
    --Select Branch--
  </MenuItem>
  {branch.map((branches) => (
    <MenuItem key={branches.branchId} value={String(branches.branchId)}>   {/* was: branches.srBranchId (both key and value) */}
      {branches.branchName}
    </MenuItem>
  ))}
</TextField>
            </div>
            {/* latest code by nabil*/}

            {/* Returned By */}
            {/* Returned By Type */}
            <div>
              <Typography variant="subtitle1" gutterBottom>
                Returned By Type <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                select
                fullWidth
                variant="outlined"
                value={selectedType}
                onChange={(e) => {
                  setSelectedType(e.target.value);
                  // Filter name options based on selected type
                  const filteredNames = stockIssuances
                    .filter(issuance => issuance.issuedToType === e.target.value)
                    .map(issuance => ({
                      issuedToID: issuance.issuedToID,
                      issuedToName: issuance.issuedToName,
                      stockIssuanceID: issuance.stockIssuanceID,
                      totalQuantity: issuance.totalQuantity
                    }));
                  setNameOptions(filteredNames);
                }}
              >
                {typeOptions.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {/* Name */}
            {/* Name */}
            <div>
              <Typography variant="subtitle1" gutterBottom>
                Name <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                select
                fullWidth
                variant="outlined"
                value={selectedName}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setSelectedName(selectedId);
                  const selected = nameOptions.find(item => item.issuedToID === selectedId);
                  if (selected) {
                    setSelectedDetails({
                      quantity: selected.totalQuantity,
                      issuedToID: selected.issuedToID,
                      stockIssuanceID: selected.stockIssuanceID,
                    });
                    fetchIssuanceDetails(selected.stockIssuanceID);
                  }
                }}
                disabled={!selectedType}
              >
                {nameOptions.length > 0 ? (
                  nameOptions.map((item) => (
                    <MenuItem key={item.issuedToID} value={item.issuedToID}>
                      {item.issuedToName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No options available</MenuItem>
                )}
              </TextField>
            </div>

            {/* Returned Date */}
            <div>
              <Typography variant="subtitle1" gutterBottom>
                Returned Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <input
                type="date"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
        </Box>

        <Box
          sx={{
            width: "100%",
            maxWidth: "600px",
            margin: "30px auto",
            padding: "24px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "24px" }}
          >
            Items Table
          </Typography>

          <TableContainer component={Paper} elevation={0}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Item Name</TableCell>
                  <TableCell align="center">Quantity Returned</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      <TextField
                        value={`${item.itemCode} - ${item.itemName}`}
                        size="small"
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{ backgroundColor: "#f9f9f9" }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={item.quantity}
                        onChange={(e) => handleNumericInputChange("quantity", e.target.value, index)}
                        inputProps={{
                          min: 0,
                          max: item.quantityIssued,
                        }}
                      />
                      <Typography variant="caption" color="textSecondary">
                        Max: {item.quantityIssued}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "16px",
            gap: "16px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}
            onClick={handleSave}
          >
            SAVE
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{
              width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}
            onClick={handleReset}
          >
            RESET
          </Button>
        </div>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


    </div>
  );
};

export default AddStockReturn;
